module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Отдел заботы"}}')
  delete Component.options._Ctor
}
